import { withProps } from 'recompose'

type Fields = object | ((props: any) => object)

export default (fields: Fields) =>
  withProps((props) => ({
    fields: typeof fields === 'function' ? fields(props) : fields,
  }))
